/*
 * Copyright (c) 2025. The content provided herein is protected by copyright law. Unauthorized use, reproduction, or distribution of this material without proper licensing, knowledge, and contract agreement from the author is strictly prohibited. Any infringement of these rights may result in legal action. For inquiries regarding the use of this content, please contact the author for proper authorization and agreement.
 */

import React from "react";
import clsx from "clsx";
import {copyToClipboard} from "utils/utility";

interface BookingLoginReservationDetailInputBlankProps {
    label?: string;
    value: string | number;
    name: string;
    className?: string;
    classNameInput?: string;
}

const BookingLoginReservationDetailInputBlank = (props: BookingLoginReservationDetailInputBlankProps) => {
    return (
        <div className={clsx("BookingLoginReservationDetailInputBlank w-full cursor-pointer", props.className)}
        >
            {props.label && (
                <label className="flex not-italic mb-1 text-sm font-medium text-gray-900"
                       htmlFor={"input_" + props.name}>
                    <em>{props.label}</em>
                </label>
            )}
            <div className={"relative w-full"}>
                <div
                    className={clsx(
                        "w-full px-3 py-1.5 rounded-md bg-gray-100 text-gray-600 border-gray-200 border",
                        props.classNameInput,
                    )}
                    onClick={() => copyToClipboard(props.value ? "" + props.value : "N/A")}
                >
                    {props.value ? props.value : "N/A"}
                </div>
            </div>
        </div>
    );
};

export default BookingLoginReservationDetailInputBlank;